<template>

</template>

<script>
    export default {
        name: "PageFooter"
    }
</script>

<style scoped>

</style>
